import { StylePropertyDefinition } from '../../types/common';

export const styleDefaults = new Map<string, string>();
export const styleProperties: Array<StylePropertyDefinition> = [];
export const stylePropertiesForTheme: Array<StylePropertyDefinition> = [];
